// extracted by mini-css-extract-plugin
module.exports = {"notification":"Notification_notification__2b54h","meta":"Notification_meta__3iwod","readby":"Notification_readby__2V4To"};